const addPageAction = (actionName, actionAttribute = {}) => {
    const nrAvailable = !!window.newrelic;
    if (nrAvailable) {
        window.newrelic.addPageAction(actionName, actionAttribute);
    }
};
export { addPageAction };
